var CHARACTER_LIMIT = 1000;
export var ADDITIONAL_INFO_COMMENT_CHARACTER_LIMIT = 250;
export var CANCEL_DISPUTE_REASON_CHARACTER_LIMIT = 100;
export default CHARACTER_LIMIT;
export var specialCharacterRegex = /[^0-9a-zA-Z~!@#$%^&*_+=?\t\n\r\b\f'"`{}[\]:;,.()\\[ -/|]/;
export var ALLOWED_SPECIAL_CHARS = '` ~ ! @ # $ % ^ & * - _ + = ? \' { } [ ] : ; , . \\ ( ) " /';
//# sourceMappingURL=characterValidation.js.map